import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'vee-dialog-footer-actions',
  templateUrl: './dialog-footer-actions.component.html',
  styleUrls: ['./dialog-footer-actions.component.scss'],
  standalone: false,
})
export class DialogFooterActionsComponent {
  @Input() cancelLabel?: string;
  @Input() saveLabel?: string;
  @Input() saveDisabled = false;
  @Input() cancelDanger = false;
  @Output() cancel = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();
}
